//@flow
import axios from 'axios'

export default (credentials: {email: string, password: string}) => {
  return axios
    .post('/login', credentials)
    .then(({data}: {data: {id_token: string, refresh_token: string}}) => {
      const idToken = data.id_token
      axios.defaults.headers.common['Authorization'] = idToken
      return data
    })
}



// WEBPACK FOOTER //
// ./src/api/login.js